<template>
  <div class="page-body">
    <b-row>
      <transition name="slide">
        <b-col cols="12" xl="12">
          <b-input-group class="mb-2">
            <b-form-input v-model="filter" placeholder="Type to Search" />
            <b-input-group-append>
              <b-btn @click="filter = ''">Clear</b-btn>
            </b-input-group-append>
          </b-input-group>
          <b-table :hover="hover"
                    :striped="striped"
                    :bordered="bordered"
                    :small="small"
                    :fixed="fixed"
                    responsive="sm"
                    :items="reports"
                    :fields="fields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :filter="filter"
                    @filtered='onFiltered'>
            <template slot='name' slot-scope="data">
              <strong>{{data.item.name}}</strong>
            </template>
            <template slot='dashboard' slot-scope="data">
              <strong>{{dashboardName(data.item.dashboard_id)}}</strong>
            </template>
            <template slot='client' slot-scope="data">
              <strong>{{clientName(data.item.client_id)}}</strong>
            </template>
            <template slot='send_to' slot-scope="data">
              <span v-for="(recipient, index) in data.item.send_to" :key="index">{{recipient}} &nbsp;</span>
            </template>
            <template slot='next_report_date' slot-scope="data">
              {{formatDate(data.item.next_report_date)}}
            </template>
            <template slot='actions' slot-scope="data">
              <b-button variant="primary" class="action-btn mr-2" @click="editReport(data.item.id, $event)" v-b-popover.hover.top="'Edit'">
                <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
              </b-button>
              <b-button variant="danger" class="action-btn" @click="showDeleteModal(data.item.id)" v-b-popover.hover.top="'Delete'">
                <i class="fa fa-trash-o" aria-hidden="true"></i>
              </b-button>
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" :total-rows="getRowCount(reports)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
          </nav>
          <b-button variant="primary" @click="$eventBus.$emit('newReportModal')">
            Schedule new report
          </b-button>
        </b-col>
      </transition>
      <ReportFormModal/>
      <b-modal title="Delete Report" class="modal-danger" v-model="deleteModal" @ok="deleteReport(currentReportId, $event)" ok-variant="danger">
        Are you sure?
      </b-modal>
    </b-row>
  </div>
</template>

<script>
import moment from 'moment'
import ReportFormModal from '@/views/modals/ReportFormModal'
import {mapGetters, mapActions} from 'vuex'
export default {
  name: 'Reports',
  components: {
    ReportFormModal
  },
  props: {
    caption: {
      type: String,
      default: 'Reports'
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      fields: [
        {key: 'name'},
        {key: 'dashboard'},
        {key: 'client'},
        {key: 'frequency'},
        {key: 'day'},
        {key: 'date_range'},
        {key: 'send_to'},
        {key: 'next_report_date'},
        {key: 'actions'}
      ],
      currentPage: 1,
      perPage: 15,
      totalRows: 0,
      filter: null,
      deleteModal: false
    }
  },

  created () {
    this.getReports()
  },

  methods: {
    ...mapActions(['getReports', 'deleteReport']),

    formatDate(date) {
      return moment(date).format('MM/DD/YYYY')
    },

    editReport(id) {
      this.$eventBus.$emit('editReportModal', id)
    },

    getRowCount (items) {
      if (!items) {return 0}
      return items.length
    },

    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    dashboardName(dashboardId) {
      let dashboard = this.dashboards.find( dashboard => dashboard.id == dashboardId )
      if (dashboard) {
        return dashboard.attributes.name
      } else {
        return ''
      }
    },

    clientName(clientId) {
      let client = this.clients.find( client => client.id == clientId )
      if (client) {
        return client.name
      } else {
        return ''
      }
    },

    showDeleteModal(reportId) {
      this.deleteModal = true
      this.currentReportId = reportId
    }
  },

  computed: {
    ...mapGetters(['currentUser', 'dashboards','clients', 'reports'])
  }

}
</script>

<style scoped>
.page-body {
  overflow: auto;
}
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
.card-body {
  margin-top: .5rem;
}
.action-btn {
  font-size: 16px;
  border-radius: 30px;
  border-color: transparent !important;
  height: 35px;
  width: 35px;
  padding: 0;
  text-align: center;
  margin-bottom: 2px;
  margin-top: 2px;
}
.card .card-header {
  font-family: 'Cooper Hewitt Semibold';
  text-transform: uppercase;
  color: #3493B2;
  letter-spacing: 2px;
}
</style>
